import React from "react";
import PropTypes from "prop-types";
import AdminEditModal from "./AdminEditModal";
import AvailableHoursNotesModal from "./Notes/AvailableHoursNotesModal";

export default function AdminButtons({ AvailableHoursRecord }) {
  return (
    <>
      <AdminEditModal AvailableHoursRecord={AvailableHoursRecord} />
      <AvailableHoursNotesModal AvailableHoursRecord={AvailableHoursRecord} />
    </>
  );
}

AdminEditModal.propTypes = {
  AvailableHoursRecord: PropTypes.object.isRequired
};
